import { debounce } from 'debounce';
import { defaultDebounceInterval } from '../constants/debounce';
import { useWindowEventListener } from './use-window-event-listener';
/**
 * Add a debounced event listener to the window object for the lifecycle of a component. Cleans up when a value in deps
 * list changes or the component unmounts.
 */ export const useDebounceWindowEventListener = (eventListener, eventType, interval, deps)=>useWindowEventListener(debounce(eventListener, interval != null ? interval : defaultDebounceInterval), eventType, deps)
;
